export default __webpack_public_path__ + "static/2023PCS_full_poster-dbd96fda348a420bc86df2fd4bc88797.webp";